module.exports = __webpack_public_path__ + "media/images/icon-plus-17c974d214e2c0c214c9e84876663a4e.svg";